import { useEffect, useState } from 'react';
import { getIntl, getFormatFunctions } from '@spa/shared/utils/date';

export const useDateFormats = language => {
  const [state, setState] = useState(getFormatFunctions());

  useEffect(() => {
    language && getIntl(language).then(setState);
  }, [language]);

  return state;
};
